import React from 'react';
import Navbar from '../components/Navbar';
import EngineHero from '../components/engine/EngineHero';
import EngineFeatures from '../components/engine/EngineFeatures';
import EngineOutcomes from '../components/engine/EngineOutcomes';
import EngineIndustries from '../components/engine/EngineIndustries';
import EngineCustomization from '../components/engine/EngineCustomization';
import EngineCTA from '../components/engine/EngineCTA';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const EnginePage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <SEO 
        title="Traain Engine | Custom Training Built for the Modern Enterprise"
        description="AI-powered Training designed for today's distributed workforce. Create consistency, confidence, and execution at scale with Traain Engine."
        keywords="enterprise training, AI training platform, custom training, Navigator AI, corporate training, workforce training"
      />
      
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-950 via-gray-900 to-indigo-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <EngineHero />
        <EngineFeatures />
        <EngineOutcomes />
        <EngineIndustries />
        <EngineCustomization />
        <EngineCTA />
        <Footer />
      </div>
    </div>
  );
};

export default EnginePage;
